// ============================================
// CONTACT SECTION - Shrileela Beach Resort
// ============================================

import { useState } from 'react';

const ContactSection = () => {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) return;
    setSent(true);
  };

  const openWhatsApp = () => {
    window.open(`https://wa.me/919404617122?text=${encodeURIComponent('Hello! I have a query about Shrileela Beach Resort.')}`, '_blank');
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=Jost:wght@300;400;500;600&display=swap');
        .contact-section {
          padding: 100px 24px;
          background: #fff;
          font-family: 'Jost', sans-serif;
        }
        .contact-inner { max-width: 1200px; margin: 0 auto; }
        .contact-header { text-align: center; margin-bottom: 64px; }
        .contact-eyebrow {
          display: inline-block; background: #e8f0e8; color: #3d5a3e;
          font-size: 11px; font-weight: 700; letter-spacing: 3px; text-transform: uppercase;
          padding: 6px 18px; border-radius: 40px; margin-bottom: 20px;
        }
        .contact-title {
          font-family: 'Playfair Display', serif; font-size: clamp(32px, 5vw, 52px);
          font-weight: 700; color: #1a2b1a; margin: 0 0 16px;
        }
        .contact-subtitle { font-size: 17px; color: #666; font-weight: 300; }

        .contact-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 40px; }

        .contact-info-card {
          background: #f8faf7; border-radius: 24px; padding: 40px;
          border: 1.5px solid #e0eae0;
        }
        .contact-info-title { font-family: 'Playfair Display', serif; font-size: 26px; color: #1a2b1a; margin: 0 0 32px; }
        .contact-info-item {
          display: flex; align-items: flex-start; gap: 18px; margin-bottom: 28px;
        }
        .contact-icon-wrap {
          width: 48px; height: 48px; background: #3d5a3e; border-radius: 14px;
          display: flex; align-items: center; justify-content: center;
          font-size: 20px; flex-shrink: 0;
        }
        .contact-info-label { font-size: 12px; font-weight: 700; color: #888; letter-spacing: 1.5px; text-transform: uppercase; margin-bottom: 6px; }
        .contact-info-val { font-size: 15px; color: #333; line-height: 1.6; }
        .contact-info-val a { color: #3d5a3e; text-decoration: none; font-weight: 500; }
        .contact-info-val a:hover { text-decoration: underline; }

        .contact-wa-btn {
          width: 100%; background: #25d366; color: #fff; border: none;
          padding: 16px; border-radius: 14px;
          font-family: 'Jost', sans-serif; font-size: 15px; font-weight: 600;
          cursor: pointer; transition: background 0.25s;
          display: flex; align-items: center; justify-content: center; gap: 8px;
          margin-top: 24px;
        }
        .contact-wa-btn:hover { background: #128c7e; }

        .map-frame { border-radius: 16px; overflow: hidden; margin-top: 24px; }

        .contact-form-card { background: #fff; border-radius: 24px; padding: 40px; border: 1.5px solid #e0e0e0; }
        .form-title { font-family: 'Playfair Display', serif; font-size: 26px; color: #1a2b1a; margin: 0 0 32px; }
        .cf-group { display: flex; flex-direction: column; gap: 6px; margin-bottom: 20px; }
        .cf-label { font-size: 13px; font-weight: 600; color: #333; }
        .cf-input, .cf-textarea {
          padding: 12px 16px; border: 1.5px solid #e0e0e0; border-radius: 10px;
          font-family: 'Jost', sans-serif; font-size: 14px; color: #333;
          transition: border-color 0.2s, box-shadow 0.2s;
        }
        .cf-input:focus, .cf-textarea:focus {
          outline: none; border-color: #3d5a3e; box-shadow: 0 0 0 3px rgba(61,90,62,0.1);
        }
        .cf-textarea { min-height: 130px; resize: vertical; }
        .cf-submit {
          width: 100%; background: #3d5a3e; color: #fff; border: none;
          padding: 16px; border-radius: 14px;
          font-family: 'Jost', sans-serif; font-size: 15px; font-weight: 600;
          cursor: pointer; transition: all 0.25s; margin-top: 8px;
        }
        .cf-submit:hover { background: #2d4230; transform: translateY(-2px); }
        .cf-success {
          text-align: center; padding: 40px 0;
        }
        .cf-success-icon { font-size: 48px; margin-bottom: 16px; }
        .cf-success-text { font-size: 16px; color: #555; }

        @media (max-width: 900px) {
          .contact-grid { grid-template-columns: 1fr; }
          .contact-form-card, .contact-info-card { padding: 28px; }
        }
      `}</style>

      <section id="contact" className="contact-section">
        <div className="contact-inner">
          <div className="contact-header">
            <span className="contact-eyebrow">Get in Touch</span>
            <h2 className="contact-title">Contact Us</h2>
            <p className="contact-subtitle">We're here to help you plan your perfect beach getaway</p>
          </div>

          <div className="contact-grid">
            <div>
              <div className="contact-info-card">
                <h3 className="contact-info-title">Resort Information</h3>

                <div className="contact-info-item">
                  <div className="contact-icon-wrap">📍</div>
                  <div>
                    <div className="contact-info-label">Address</div>
                    <div className="contact-info-val">Near Durga Devi Temple,<br />Murud Beach, Tal. Dapoli,<br />Dist. Ratnagiri – 415713</div>
                  </div>
                </div>

                <div className="contact-info-item">
                  <div className="contact-icon-wrap">📞</div>
                  <div>
                    <div className="contact-info-label">Phone</div>
                    <div className="contact-info-val">
                      <a href="tel:+919404617122">+91 9404617122</a><br />
                      <a href="tel:+919404992515">+91 9404992515</a><br />
                      <a href="tel:+919423296526">+91 9423296526</a>
                    </div>
                  </div>
                </div>

                <div className="contact-info-item">
                  <div className="contact-icon-wrap">✉️</div>
                  <div>
                    <div className="contact-info-label">Email</div>
                    <div className="contact-info-val">
                      <a href="mailto:chaitulhospitalityllp@gmail.com">chaitulhospitalityllp@gmail.com</a>
                    </div>
                  </div>
                </div>

                <div className="contact-info-item" style={{ marginBottom: 0 }}>
                  <div className="contact-icon-wrap">🕐</div>
                  <div>
                    <div className="contact-info-label">Check-in / Check-out</div>
                    <div className="contact-info-val">Check-in: 12:00 PM<br />Check-out: 11:00 AM</div>
                  </div>
                </div>

                <button className="contact-wa-btn" onClick={openWhatsApp}>
                  <span>💬</span> Chat on WhatsApp
                </button>
              </div>

              <div className="map-frame">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.0!2d73.1800!3d17.7750!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be9c7d4cdc9a815%3A0xcfecb5f13416c2b1!2sMurud+Beach!5e0!3m2!1sen!2sin!4v1234567890"
                  width="100%" height="260" style={{ border: 0, display: 'block' }}
                  allowFullScreen="" loading="lazy"
                  title="Shrileela Beach Resort Location"
                />
              </div>
            </div>

            <div className="contact-form-card">
              <h3 className="form-title">Send Us a Message</h3>
              {sent ? (
                <div className="cf-success">
                  <div className="cf-success-icon">🌊</div>
                  <div className="cf-success-text">Message sent! We'll get back to you shortly.</div>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="cf-group">
                    <label className="cf-label">Your Name *</label>
                    <input type="text" className="cf-input" placeholder="Enter your name"
                      value={form.name} onChange={e => set('name', e.target.value)} required />
                  </div>
                  <div className="cf-group">
                    <label className="cf-label">Email Address *</label>
                    <input type="email" className="cf-input" placeholder="your@email.com"
                      value={form.email} onChange={e => set('email', e.target.value)} required />
                  </div>
                  <div className="cf-group">
                    <label className="cf-label">Subject</label>
                    <input type="text" className="cf-input" placeholder="What is this regarding?"
                      value={form.subject} onChange={e => set('subject', e.target.value)} />
                  </div>
                  <div className="cf-group">
                    <label className="cf-label">Message *</label>
                    <textarea className="cf-textarea" placeholder="Your message..."
                      value={form.message} onChange={e => set('message', e.target.value)} required />
                  </div>
                  <button type="submit" className="cf-submit">Send Message →</button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactSection;